import { ROUTE } from "../../routes";
import SharedPropsService from "../../SharedPropsService";
import { nextStepCredStepper } from "../../configs/utils";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { WIDGET } from "@voltmoney/schema";
let hasNavigated = false;
let routeObj;
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const goBack = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_STEPPER);
};
export const submitAction = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const uploadDocumentsAction = async (action, _datastore, { navigate, removeWidgets }) => {
    await removeWidgets(ROUTE.AS_ES_INDIVIDUAL_DOCUMENT, [
        { id: "asESIndividualDocumentDC", type: WIDGET.AS_ES_INDIVIDUAL_DOCUMENT }
    ]);
    await navigate(ROUTE.AS_ES_INDIVIDUAL_DOCUMENT, {
        documentDetails: action?.payload?.documentDetails
    });
};
export const proceedToNextStep = async (action, _datastore, { navigateWithClear, network }) => {
    let applicationId;
    if (await AsyncStorage.getItem("application_id")) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        const user = await SharedPropsService.getUser();
        applicationId = user.linkedApplications[0].applicationId;
    }
    const submitDocVerify = await network.post(`${api.submitAllDocs}`, {
        applicationId: applicationId
    }, {
        headers: await getAppHeader(),
    });
    const submitDocData = submitDocVerify?.data;
    if (submitDocData?.status === "SUCCESS") {
        const stepStatusMap = submitDocData?.updatedApplicationObj?.stepStatusMap;
        routeObj = await nextStepCredStepper("", stepStatusMap);
        if (!hasNavigated) {
            setTimeout(async () => {
                await navigateWithClear(routeObj.routeId, routeObj.params);
            }, 3000);
        }
    }
};
export const continueAction = async (action, _datastore, { navigateWithClear }) => {
    hasNavigated = true;
    await navigateWithClear(routeObj.routeId, routeObj.params);
};
